// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header___LK5J","container":"styles_container__2czXL","title":"styles_title__3PG82","wrapper":"styles_wrapper__3owGt","answer":"styles_answer__2TRW5"};